export default {"src":"https://s.sylndr.com/c-3732c05/_next/static/media/background.270aa3c8.svg","height":684,"width":1440,"blurWidth":0,"blurHeight":0};